import React from "react";
import { SaveOutlined, CheckOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import ExpenseRefund from "../../../services/api/ExpenseRefund";
import { useState } from "react";
import { Col, Row, Skeleton } from "antd";
import { checkSendInApprove, showError } from "../../../utils/utilities";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import Button from "../../../components/functional_components/Button/PFButton";

function SaveOrApprove({ id, closeModal, sendInApprove, canEdit }) {
  const { t } = useTranslation();
  const [state, setState] = useState({
    dataEdit: {},
    loading: false,
    checkSendInApprove: false,
  });
  useEffect(() => {
    editCallback();
  }, []);
  const editCallback = async () => {
    let dataEdit = {};
    setState((prevState) => ({ ...prevState, loading: true }));
    const { data, error } = await ExpenseRefund.getExpenseRefund(id);
    if (!error && data) {
      dataEdit = data;
    } else {
      showError(get(error, "messageCode", "ER000"));
    }
    setState((prevState) => ({
      ...prevState,
      loading: false,
      dataEdit,
      checkSendInApprove: checkSendInApprove({
        status: data.status,
        type: data.type,
        flight: data.flight,
        documents: data.documents,
        traceablePayment: data.traceablePayment,
      }),
    }));
  };
  return state.loading ? (
    <>
      <Row justify="center">
        <Col span={10} style={{ textAlign: "center" }}>
          <h3>
            <b>{t("expenseRefundFolder.table.calcRefund")}</b>
          </h3>
        </Col>
      </Row>
      <Row justify="center" className="mb-1em">
        <Col span={10} style={{ textAlign: "center" }}>
          <Skeleton.Input size="small" />
        </Col>
      </Row>
      <Row justify="center">
        <Col span={6} style={{ textAlign: "center" }}>
          <Skeleton.Button />
        </Col>
        <Col span={6} style={{ textAlign: "center" }}>
          <span>{t("expenseRefundFolder.or")}</span>
        </Col>
        <Col span={6} style={{ textAlign: "center" }}>
          <Skeleton.Button />
        </Col>
      </Row>
    </>
  ) : (
    <>
      <Row justify="center">
        <Col span={10} style={{ textAlign: "center" }}>
          <h3>
            <b>{t("expenseRefundFolder.table.calcRefund")}</b>
          </h3>
        </Col>
      </Row>
      <Row justify="center" className="mb-1em">
        <Col span={10} style={{ textAlign: "center" }}>
          {state.dataEdit.calcRefund || "-"} €
        </Col>
      </Row>
      <Row justify="center">
        <Col span={6} style={{ textAlign: "center" }}>
          <Button
            isDisabled={!canEdit}
            currentIcon={<SaveOutlined className="icon-medium" />}
            clickCallback={closeModal}
            content={t("expenseRefundFolder.save")}
          />
        </Col>
        <Col span={6} style={{ textAlign: "center" }}>
          <span>{t("expenseRefundFolder.or")}</span>
        </Col>
        <Col span={6} style={{ textAlign: "center" }}>
          <Button
            currentIcon={<CheckOutlined className="icon-medium" />}
            clickCallback={() => sendInApprove([{ id }])}
            isDisabled={!canEdit || !state.checkSendInApprove}
            content={t("expenseRefundFolder.approve")}
          />
        </Col>
      </Row>
    </>
  );
}
export default SaveOrApprove;
